import React from 'react';

import { Typography, Divider } from '@mui/material';

import { Listing } from '@klokhuis/core/ApiClient/Klokhuis';
import { useIntl } from '@klokhuis/core/Intl';
import { useListingSelectors } from '@klokhuis/modules/Properties/context/hooks/useListingSelectors';
import { CommonStyles } from '@klokhuis/styles/CommonStyles';
import { groupByKey } from '@klokhuis/utilities/Array/groupByKey';

import { GridGenerator } from '../../GridGenerator/GridGenerator';

export const NearbyListings = () => {
  const nearbyListings = useListingSelectors().getNearbyListings();
  const { T } = useIntl();
  const nearbyListingsByCity = groupByKey(
    nearbyListings as Listing[],
    'cityName',
  );

  if (!nearbyListings || nearbyListings.length === 0) return null;

  return (
    <div>
      <Divider className={CommonStyles.margin_bottom_3} />
      <Typography
        variant="h5"
        fontWeight={700}
        className={CommonStyles.padding_block_1}
      >
        {T('lbl.nearby.properties.heading')}
      </Typography>
      {Object.entries(nearbyListingsByCity).map(
        ([city, cityListings], index) => (
          <React.Fragment key={city}>
            <Typography variant="h6" className={CommonStyles.padding_block_1}>
              {city}
            </Typography>
            <GridGenerator listings={cityListings} />
            {index !== Object.entries(nearbyListingsByCity).length - 1 && (
              <Divider className={CommonStyles.margin_bottom_3} />
            )}
          </React.Fragment>
        ),
      )}
    </div>
  );
};
